const Company = {
    name: 'Fund Genies',
    email: 'fundgeniesllc@gmail.com',
}

export default Company